<template>
    <participant-details-component :ui="'admin'" :routeToList="'admin-participants-list'"></participant-details-component>
</template>

<script>
import ParticipantDetailsComponent from '@/components/Admin-Employee/Participant/Details/ParticipantDetailsComponent.vue'

export default {
    name: "ParticipantDetails",
    components: { ParticipantDetailsComponent },
    data: () => ({}),
}
</script>